module.exports = __webpack_public_path__ + "static/media/(LH)-08-Capim-Dourado-bijuterias.66715017.jpg";